import { render } from "./CreateRequest.vue?vue&type=template&id=beffcffc"
import script from "./CreateRequest.vue?vue&type=script&lang=js"
export * from "./CreateRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__